module.exports = __webpack_public_path__ + "img/startup-bg.d29f6d0c.jpg";